
const theme={
colors:{
    primary:'#aa9a73',
    secondary:'#9e4f06',
    blue:'#04009A',
    light:'#fff',
    dark:'#212529',
    lightGray:'#54667e12',
    darkGray:'#54667E',
    green:'#00AF14',
}
}

export default theme;